import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);

        // Options
        this.delay = parseFloat(this.getData('delay')) || 0.0;
        this.stagger = parseFloat(this.getData('stagger')) || 0.15;
    }

    init() {
        setTimeout(() => {
            this.reSplit()
        }, 5000);
    }

    split() {
        this.splitObject = new SplitText(this.el, {
            type: "lines",
            tag: "span"
        });
        this.splitObject.lines.forEach((line, i) => {
            line.style.transitionDelay = `${this.delay + (i * this.stagger)}s`
        });
    }

    reSplit() {
        this.splitObject?.revert?.();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.split();
            })
        })
    }

    destroy() {
        this.splitWords.revert();
        this.splitWords = null;
        this.words = null;
    }
}
